export default "__VITE_ASSET__b3dc3a75__"